export default {"src":"/_next/static/media/icon-loomis.f60040b2.svg","height":20,"width":36,"blurWidth":0,"blurHeight":0};